import { render } from "./DashboardCms.vue?vue&type=template&id=7b7a20e0&scoped=true"
import script from "./DashboardCms.vue?vue&type=script&lang=js"
export * from "./DashboardCms.vue?vue&type=script&lang=js"

import "./DashboardCms.vue?vue&type=style&index=0&id=7b7a20e0&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b7a20e0"]])

export default __exports__